import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {MainPage} from "./pages/MainPage";
import LoginPage from "./pages/LoginPage";
import {Header} from "./components/Header";
import {Footer} from "./components/Footer";
import {ErrorPage} from "./pages/ErrorPage";
import {AuthProvider} from "./contexts/AuthContext";
import {PrivateRoute} from "./components/PrivateRoute";
import {ProfilePage} from "./pages/ProfilePage";
import HomePage from "./pages/HomePage";
import RegistrationForm from "./components/RegistrationForm";
import {AdminPage} from "./pages/AdminPage";
import AdminCreateAgent from "./pages/AdminCreateAgent";
import AdminDeleteKyc from "./pages/AdminDeleteKyc";
import AdminRegisterUser from "./pages/AdminRegisterUser";
import AdminApproveMerchant from "./pages/AdminApproveMerchant";
import AdminReports from "./pages/AdminReports";
import DynamicApplicationForm from "./components/OnlineApplicationForm";

function App() {
  return (
   <AuthProvider>
       <Router>
           <div className="flex flex-col min-h-screen">
               <Header />
               <main  className="flex-grow p-4">
                   <Routes>
                       <Route path="/" element={<LoginPage />}/>
                       <Route path="/error" element={<ErrorPage />}/>

                       {/*private routes*/}
                       <Route path="/register-subscriber" element={ <PrivateRoute> <RegistrationForm/> </PrivateRoute> }/>
                       <Route path="/home" element={<PrivateRoute> <HomePage /> </PrivateRoute>  }/>
                       <Route path="/search-dashboard" element={<PrivateRoute> <MainPage /> </PrivateRoute>  }/>
                       <Route path="/profile" element={<PrivateRoute> <ProfilePage /> </PrivateRoute>  }/>
                      <Route path="/admin" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
                      <Route path="/admin/create-agent" element={<PrivateRoute><AdminCreateAgent /></PrivateRoute>} />
                      <Route path="/admin/delete-kyc" element={<PrivateRoute><AdminDeleteKyc /></PrivateRoute>} />
                      <Route path="/admin/register-user" element={<PrivateRoute><AdminRegisterUser /></PrivateRoute>} />
                      <Route path="/admin/approve-merchant" element={<PrivateRoute><AdminApproveMerchant /></PrivateRoute>} />
                      <Route path="/admin/reports" element={<PrivateRoute><AdminReports /></PrivateRoute>} />
                       <Route path="/online-application" element={<PrivateRoute><DynamicApplicationForm /></PrivateRoute>} />

                   </Routes>
               </main>
               <Footer />
           </div>
       </Router>
   </AuthProvider>
  );
}

export default App;